import { useCallback } from 'react';
import { useTracker } from '@archipro-website/tracker';

/** Logs the reader following the project's byline to the professional's profile. */
export const useTrackProjectProfileClick = () => {
    const tracker = useTracker();
    return useCallback(() => {
        void tracker.log('ProjectProfileClick', {
            url: new URL(window.location.href),
            targetTracker: 'archiproTracker',
        });
    }, [tracker]);
};
